import React from "react";

import RatingSvg from "../../assets/images/icons/Form Controls/Rating.svg";

export const RatingIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={RatingSvg}
        alt={alt || "Rating"}
    />
);
